import { StatusPill } from '../../../components/primitives/StatusPill'
import { runStateToStatus } from '../../../lib/run-state-status'

export { runStateToStatus }

export function RunStatusPill({ state }: { state: string }) {
  return <StatusPill status={runStateToStatus(state)}>{state}</StatusPill>
}
